<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="converter.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div
            *ngIf="exchangeProtocolOptions?.length !== 1"
            class="field">
            <label class="font-medium required-field">Протокол обмена</label>
            <p-selectButton
              [options]="exchangeProtocolOptions"
              [(ngModel)]="converter.exchangeProtocol"
              optionLabel="label"
              optionValue="value"></p-selectButton>
            <small
              *ngIf="errors?.exchangeProtocol"
              class="p-error">
              {{ errors.exchangeProtocol | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Протокол считывателя карт</label>
            <p-selectButton
              [options]="readerProtocolOptions"
              [(ngModel)]="converter.readerProtocol"
              optionLabel="label"
              optionValue="value"></p-selectButton>
            <small
              *ngIf="errors?.readerProtocol"
              class="p-error">
              {{ errors.readerProtocol | join }}
            </small>
          </div>

          <div
            *ngIf="!(form$ | async).isEdit"
            class="field">
            <label class="font-medium required-field">Пароль</label>
            <div class="p-inputgroup">
              <button
                type="button"
                pButton
                style="width: 50px !important"
                [icon]="showPassword ? 'pi pi-eye' : 'pi pi-eye-slash'"
                (click)="showPassword = !showPassword"></button>
              <crm-input-text
                [(value)]="converter['password']"
                [type]="showPassword ? 'text' : 'password'"
                class="w-full border-noround"
                autocomplete="new-password"></crm-input-text>
              <button
                type="button"
                pButton
                label="Сгенерировать"
                (click)="generatePassword()"></button>
            </div>
          </div>

          <div class="field-checkbox mt-3">
            <p-checkbox
              [(ngModel)]="converter.invertEvents.controller"
              [binary]="true"
              inputId="controller"></p-checkbox>
            <label [for]="'controller'">Инверсия контроллера</label>
          </div>

          <div class="field-checkbox mt-3">
            <p-checkbox
              [(ngModel)]="converter.invertEvents.manualOpen"
              [binary]="true"
              inputId="manualOpen"></p-checkbox>
            <label [for]="'manualOpen'">Инверсия кнопки</label>
          </div>

          <div class="field-checkbox mt-3">
            <p-checkbox
              [(ngModel)]="converter.lockSettings.canLock"
              [binary]="true"
              inputId="canLock"></p-checkbox>
            <label [for]="'canLock'">Разрешена блокировка устройства</label>
          </div>

          <div class="field mt-3">
            <label class="font-medium">Задержка перед разблокировкой</label>
            <p-inputNumber
              [(ngModel)]="converter.lockSettings.unlockDelay"
              suffix=" сек.">
            </p-inputNumber>
          </div>

          <div class="field mb-0">
            <label class="font-medium">Датчик блокировки</label>
            <crm-net-ping-device-single-select
              [selectedNetPingDevice]="converter.lockSettings.netPingDevice"
              (selectedNetPingDeviceChange)="setNetPingDevice($event)"></crm-net-ping-device-single-select>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success mr-2"
        (click)="saveConverter()"></button>
      <div class="flex align-items-center gap-2">
        <button
          *ngIf="(form$ | async)?.isShowDelete"
          pButton
          label="Удалить"
          class="p-button-danger p-button-text"
          (click)="deleteConverter()"></button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
